
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("03pNx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $3u5lg = parcelRequire("3u5lg");


var $9HkI0 = parcelRequire("9HkI0");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");


var $bQm3c = parcelRequire("bQm3c");


var $ecUYt = parcelRequire("ecUYt");


var $fWGpT = parcelRequire("fWGpT");


var $j8hiR = parcelRequire("j8hiR");





var $9137z = parcelRequire("9137z");


var $dPJCf = parcelRequire("dPJCf");


var $5Za2S = parcelRequire("5Za2S");




const $3939153f8cab4d4a$export$bb6d085b131eaced = 1000; // milliseconds
const $3939153f8cab4d4a$var$TimedOut = Symbol('TimedOut');
async function $3939153f8cab4d4a$export$48fabe4a40c2858a(contentId, transitionId) {
    const initialLoad = !transitionId;
    const preload = window.__PRELOAD_DRAFT__;
    if (!initialLoad || // preloaded draft only makes sense for initial load
    !preload || preload.contentId !== contentId) return null;
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT, preload.startTime);
    const timeoutPromise = new Promise((resolve)=>setTimeout(resolve, $3939153f8cab4d4a$export$bb6d085b131eaced, $3939153f8cab4d4a$var$TimedOut));
    // In happy path, this will resolve immediately, since the draft fetch initiated in preloader
    // However, if the draft fetch is still pending, the wait will be limited to DRAFT_FETCH_TIMEOUT
    const awaitResult = await Promise.race([
        (0, $5Za2S.getDraftFromPromise)(contentId, preload.draftFetchPromise),
        timeoutPromise
    ]);
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT);
    if (awaitResult === $3939153f8cab4d4a$var$TimedOut) {
        (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT);
        return null;
    }
    return awaitResult;
}
function $3939153f8cab4d4a$export$6af0fd9cc35e7328(contentId) {
    const transitionId = (0, $dPJCf.useTransitionId)();
    const preloadedDraftPromise = (0, $cozmU.useMemo)(()=>$3939153f8cab4d4a$export$48fabe4a40c2858a(contentId, transitionId), [
        contentId,
        transitionId
    ]);
    return {
        preloadedDraftPromise: preloadedDraftPromise
    };
}



var $j7xMJ = parcelRequire("j7xMJ");





var $dYcT6 = parcelRequire("dYcT6");


var $1mHQU = parcelRequire("1mHQU");


var $c0rhi = parcelRequire("c0rhi");


var $i9VoI = parcelRequire("i9VoI");


var $jv3O2 = parcelRequire("jv3O2");


var $3jwuS = parcelRequire("3jwuS");


var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $b4EKK = parcelRequire("b4EKK");


var $hBkCm = parcelRequire("hBkCm");

var $9kGfD = parcelRequire("9kGfD");

const $ed9855f47d383028$export$5db3a73aad04cdb9 = (options)=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>`/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: (response)=>({
                traceId: (0, $9kGfD.getTraceIdFromResponse)(response) ?? ''
            }),
        parseResult: (json)=>({
                experimentalResetCollabService: {
                    traceId: json.traceId
                }
            }),
        transformError: async (error)=>{
            const response = error instanceof (0, $hBkCm.BadStatusError) ? error.response : undefined;
            if (response) return (0, $b4EKK.getErrorWithResponse)(error, response);
            return error;
        },
        variables: options?.variables
    });
};



var $7aRa9 = parcelRequire("7aRa9");


var $7QM6o = parcelRequire("7QM6o");





var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $efvKr = parcelRequire("efvKr");


var $jacyh = parcelRequire("jacyh");


var $hNtOj = parcelRequire("hNtOj");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ek3aD = parcelRequire("ek3aD");


var $5MyXJ = parcelRequire("5MyXJ");








var $1gh0Q = parcelRequire("1gh0Q");





var $lTECB = parcelRequire("lTECB");





var $1kHsc = parcelRequire("1kHsc");


var $7W8i8 = parcelRequire("7W8i8");











var $hYoU4 = parcelRequire("hYoU4");







class $d02d68b10a1bdf4e$export$6f959d0aa105c726 extends Error {
    constructor(message){
        super(message);
        this.name = 'WaitForPublishButtonComponentUnmountedError';
    }
}
class $d02d68b10a1bdf4e$export$a57f7fcfe182c834 extends Error {
    constructor(message){
        super(message);
        this.name = 'WaitForPublishButtonPreviousCallNotCompletedError';
    }
}
class $d02d68b10a1bdf4e$export$b7ed6be90d59a697 extends Error {
    constructor(message){
        super(message);
        this.name = 'WaitForPublishButtonTimeoutError';
    }
}
class $d02d68b10a1bdf4e$export$3ef0ce967d23fda8 extends Error {
    constructor(message){
        super(message);
        this.name = 'WaitForPublishButtonTabInactiveError';
    }
}
const $d02d68b10a1bdf4e$var$PUBLISH_BUTTON_SELECTOR = '[data-testid="publish-modal-update-button"], [data-testid="publish-button"], [data-testid="scheduled-button"], [data-testid="publish-button-ui"]';
// Interval in milliseconds between checks for the publish button to be enabled.
const $d02d68b10a1bdf4e$var$CHECK_INTERVAL = 2000;
// These many milliseconds after checks start, the experience will timeout and fail.
const $d02d68b10a1bdf4e$var$EXP_TIMEOUT_LENGTH = 20000;
const $d02d68b10a1bdf4e$var$ANALYTICS_ONLY_TIMEOUT_LENGTH = 20000;
const $d02d68b10a1bdf4e$var$getTimeoutLength = ()=>{
    return (0, $6mKj3.expValEquals)('cc_delay_succeeding_edit_page_until_publish_button', 'isEnabled', true) ? $d02d68b10a1bdf4e$var$EXP_TIMEOUT_LENGTH : $d02d68b10a1bdf4e$var$ANALYTICS_ONLY_TIMEOUT_LENGTH;
};
const $d02d68b10a1bdf4e$var$getPublishButton = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector($d02d68b10a1bdf4e$var$PUBLISH_BUTTON_SELECTOR);
};
const $d02d68b10a1bdf4e$var$isPublishButtonEnabled = ()=>{
    const publishButton = $d02d68b10a1bdf4e$var$getPublishButton();
    return publishButton && publishButton.disabled === false;
};
const $d02d68b10a1bdf4e$var$getTimeoutErrorMessage = ()=>{
    let errorMessage = '';
    if (!$d02d68b10a1bdf4e$var$getPublishButton()) errorMessage = 'Did not find a publish button before timeout';
    else if (!$d02d68b10a1bdf4e$var$isPublishButtonEnabled()) errorMessage = 'Found a publish button, but it was not enabled before timeout';
    else errorMessage = 'Found an enabled publish button.  This should not be an error.';
    return errorMessage;
};
const $d02d68b10a1bdf4e$export$83f4a40ecd1f63e5 = ()=>{
    const checkerIntervalRef = (0, $cozmU.useRef)(null);
    const timeoutRef = (0, $cozmU.useRef)(null);
    const currentPromiseRejectFunctionRef = (0, $cozmU.useRef)(null);
    const visibilityChangeListenerRef = (0, $cozmU.useRef)(null);
    const rejectPromiseDueToUnmount = (0, $cozmU.useCallback)(()=>{
        if (currentPromiseRejectFunctionRef.current !== null) currentPromiseRejectFunctionRef.current(new $d02d68b10a1bdf4e$export$6f959d0aa105c726('Component unmounted before the publish button was enabled'));
    }, []);
    const rejectPromiseDueToRepeatedCall = (0, $cozmU.useCallback)(()=>{
        if (currentPromiseRejectFunctionRef.current !== null) currentPromiseRejectFunctionRef.current(new $d02d68b10a1bdf4e$export$a57f7fcfe182c834('waitForPublishButtonToBeEnabled was called again before the publish button was enabled'));
    }, []);
    const cleanupIntervals = (0, $cozmU.useCallback)(()=>{
        if (checkerIntervalRef.current !== null) {
            clearInterval(checkerIntervalRef.current);
            checkerIntervalRef.current = null;
        }
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (visibilityChangeListenerRef.current !== null) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.removeEventListener('visibilitychange', visibilityChangeListenerRef.current);
            visibilityChangeListenerRef.current = null;
        }
    }, []);
    // Reject the pending Promise and cancel timeouts and intervals on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanupIntervals();
            rejectPromiseDueToUnmount();
        };
    }, [
        cleanupIntervals,
        rejectPromiseDueToUnmount
    ]);
    return (0, $cozmU.useCallback)(()=>{
        // Clean up any existing intervals/timeouts
        cleanupIntervals();
        rejectPromiseDueToRepeatedCall();
        return new Promise((resolve, reject)=>{
            // Save this reject function so we can later call it if the component unmounts.
            currentPromiseRejectFunctionRef.current = reject;
            // Check if button is already enabled
            if ($d02d68b10a1bdf4e$var$isPublishButtonEnabled()) {
                resolve();
                return;
            }
            // Check if this tab is currently inactive.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.visibilityState === 'hidden') {
                reject(new $d02d68b10a1bdf4e$export$3ef0ce967d23fda8('Could not search for the publish button because this tab is inactive'));
                return;
            }
            // Add an event listener to check if the tab become inactive while waiting for the publish button to be enabled.
            const visibilityChangeEventListener = ()=>{
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                if (document.visibilityState === 'hidden') {
                    cleanupIntervals();
                    reject(new $d02d68b10a1bdf4e$export$3ef0ce967d23fda8('Could not search for the publish button because this tab became inactive'));
                }
            };
            visibilityChangeListenerRef.current = visibilityChangeEventListener;
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.addEventListener('visibilitychange', visibilityChangeEventListener);
            // Set up interval to continuously check button state
            checkerIntervalRef.current = setInterval(()=>{
                if ($d02d68b10a1bdf4e$var$isPublishButtonEnabled()) {
                    cleanupIntervals();
                    resolve();
                }
            }, $d02d68b10a1bdf4e$var$CHECK_INTERVAL);
            // Set up timeout to reject after TIMEOUT_LENGTH
            timeoutRef.current = setTimeout(()=>{
                cleanupIntervals();
                if ($d02d68b10a1bdf4e$var$isPublishButtonEnabled()) resolve();
                else reject(new $d02d68b10a1bdf4e$export$b7ed6be90d59a697($d02d68b10a1bdf4e$var$getTimeoutErrorMessage()));
            }, $d02d68b10a1bdf4e$var$getTimeoutLength());
        });
    }, [
        cleanupIntervals,
        rejectPromiseDueToRepeatedCall
    ]);
};


const $6c2bcd900cfaf680$var$logger = (0, $7W8i8.getLogger)('native-collab');
const $6c2bcd900cfaf680$export$e8232107184b2af1 = (collabEditProvider, contentId, isCompanyHub, isRovoLLMEnabled)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ collabEditInitialized: collabEditInitialized }, nativeCollabActions] = (0, $hYoU4.useNativeCollabState)();
    const [title, setTitle] = (0, $cozmU.useState)(null);
    // Track whether the doc was empty at init time (new live doc with no content).
    // Use a ref (not state) so the value is set synchronously in the init handler —
    // metadata:changed can fire immediately after init before React processes state updates.
    // Defaults to true so the first pre-init metadata:changed is suppressed for new docs.
    const isDocEmptyRef = (0, $cozmU.useRef)(true);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let currentEditorPageLoadExperienceName = (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    if (isLivePage) currentEditorPageLoadExperienceName = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    if (isCompanyHub) currentEditorPageLoadExperienceName = (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE);
    const waitForPublishButtonToBeEnabled = (0, $d02d68b10a1bdf4e$export$83f4a40ecd1f63e5)();
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleInit = (data)=>{
            $6c2bcd900cfaf680$var$logger.debug`Collab Provider initialised at ${performance.now() / 1000}`;
            const newTitle = data?.metadata?.title ?? '';
            // For cwr_blank_object_experiment variant1 and variant2 on live docs,
            // do not auto-populate the title from the backend - leave it blank so
            // the user sees the "New live doc" placeholder text instead.
            // Only suppress when AI is enabled, the page is a live page, the doc
            // content is empty (BOE experience is shown), and the experiment is active.
            // Check if the ADF doc from the init payload is empty (matches the same
            // logic as isEmptyDocument in @confluence/rovo-editor-bridge-listener and
            // @atlassian/editor-rovo-bridge — a single empty paragraph/heading counts as empty).
            const doc = data?.doc;
            const docIsEmpty = !doc?.content || doc.content.length === 0 || doc.content.length === 1 && (doc.content[0].type === 'paragraph' || doc.content[0].type === 'heading') && (!doc.content[0].content || doc.content[0].content.length === 0);
            isDocEmptyRef.current = docIsEmpty;
            const shouldSuppressTitle = isLivePage && isRovoLLMEnabled && docIsEmpty && (0, $1gh0Q.isDefaultLiveDocTitle)(newTitle) && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'));
            setTitle(shouldSuppressTitle ? '' : newTitle);
            nativeCollabActions.setCollabEditInitialized(true);
            // marking provider initialization as complete once FE receives "init" event
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_DISABLED);
            // tracking time between when 'init' event is fired and connection has been established
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT_DOC);
            const commonAttributes = {
                collabService: 'ncs',
                isLivePage: isLivePage
            };
            const onSuccess = ()=>{
                experienceTracker.succeed({
                    name: currentEditorPageLoadExperienceName,
                    attributes: {
                        ...commonAttributes
                    }
                });
            };
            const onFailure = (error)=>{
                if (error instanceof (0, $d02d68b10a1bdf4e$export$6f959d0aa105c726) || error instanceof (0, $d02d68b10a1bdf4e$export$a57f7fcfe182c834) || error instanceof (0, $d02d68b10a1bdf4e$export$3ef0ce967d23fda8)) experienceTracker.abort({
                    name: currentEditorPageLoadExperienceName,
                    reason: error.message,
                    attributes: {
                        ...commonAttributes
                    },
                    checkForTimeout: false
                });
                else experienceTracker.fail({
                    name: currentEditorPageLoadExperienceName,
                    attributes: {
                        ...commonAttributes,
                        failureReason: error.message
                    },
                    error: error
                });
            };
            const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
            if (isLivePage || isEmbedded) onSuccess();
            else {
                if (!(0, $6mKj3.expValEquals)('cc_delay_succeeding_edit_page_until_publish_button', 'isEnabled', true)) // When experiment is disabled, succeed edit-page/load immediately.
                onSuccess();
                waitForPublishButtonToBeEnabled().then(()=>{
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'enabled',
                            actionSubject: 'editPagePublishButton',
                            source: 'useInit',
                            objectId: contentId
                        }
                    }).fire();
                    if ((0, $6mKj3.expValEquals)('cc_delay_succeeding_edit_page_until_publish_button', 'isEnabled', true)) // When experiment is enabled, succeed edit-page/load after publish button appears.
                    onSuccess();
                }, (error)=>{
                    const wouldBeAnAbort = error instanceof (0, $d02d68b10a1bdf4e$export$6f959d0aa105c726) || error instanceof (0, $d02d68b10a1bdf4e$export$a57f7fcfe182c834) || error instanceof (0, $d02d68b10a1bdf4e$export$3ef0ce967d23fda8);
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'failedToEnable',
                            actionSubject: 'editPagePublishButton',
                            source: 'useInit',
                            objectId: contentId,
                            attributes: {
                                wouldBeAnAbort: wouldBeAnAbort,
                                errorMessage: error.message
                            }
                        }
                    }).fire();
                    if ((0, $6mKj3.expValEquals)('cc_delay_succeeding_edit_page_until_publish_button', 'isEnabled', true)) // When experiment is enabled, fail edit-page/load after timeout.
                    onFailure(error);
                });
            }
        };
        collabEditProvider.on('init', handleInit);
        return ()=>{
            collabEditProvider.off('init', handleInit);
            const experienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
            const experienceHasStopped = experienceState?.hasStopped ?? true;
            const experienceMatchesContentId = experienceState?.attributes?.contentId === contentId;
            // If we leave the editor page and the page we transition to immediately calls `useInit` (e.g. going from edit/live page to live page), this logic may undesirably try to abort the newly started experience. Using `experienceMatchesContentId` prevents this.
            if (!experienceHasStopped && experienceMatchesContentId) experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: 'Unmounted before experience finished',
                attributes: {
                    isLivePage: isLivePage
                }
            });
        };
    }, [
        waitForPublishButtonToBeEnabled,
        collabEditProvider,
        experienceTracker,
        nativeCollabActions,
        currentEditorPageLoadExperienceName,
        isLivePage,
        isRovoLLMEnabled,
        contentId,
        createAnalyticsEvent
    ]);
    return {
        collabEditInitialized: collabEditInitialized,
        titleFromInit: title,
        isDocEmptyRef: isDocEmptyRef
    };
};



var $5M5fB = parcelRequire("5M5fB");













const $4cea9cbb27e2f2c9$export$e85f4ef42a672a12 = (collabEditProvider, onMetadataChange, isLivePage, isRovoLLMEnabled, isDocEmptyRef)=>{
    const [title, setTitle] = (0, $cozmU.useState)(null);
    const [{ collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    // Use a ref so the event handler always reads the latest collabEditInitialized
    // value without needing to re-register the handler on every state change.
    const collabEditInitializedRef = (0, $cozmU.useRef)(collabEditInitialized);
    collabEditInitializedRef.current = collabEditInitialized;
    const onTitleChange = (0, $cozmU.useCallback)((newTitle)=>{
        if (collabEditProvider) {
            setTitle(newTitle);
            const metadata = collabEditProvider.getMetadata();
            collabEditProvider.setMetadata({
                ...metadata,
                metadataSource: 'client',
                title: newTitle
            });
        }
    }, [
        collabEditProvider
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleTitleChanged = (data)=>{
            if (!data || !('title' in data)) return;
            const { title: title } = data;
            // For cwr_blank_object_experiment variant1 and variant2 on live docs,
            // only suppress the auto-generated title on initial load (before collab
            // has initialized). Once initialized, metadata:changed events represent
            // user edits and should pass through normally.
            // Only suppress when AI is enabled, the page is a live page, the doc
            // was empty at init time (BOE experience is shown), not yet initialized,
            // and the experiment is active.
            const shouldSuppressTitle = isLivePage && isRovoLLMEnabled && isDocEmptyRef?.current && !collabEditInitializedRef.current && (0, $1gh0Q.isDefaultLiveDocTitle)(title) && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'));
            setTitle(shouldSuppressTitle ? '' : title);
            onMetadataChange?.();
        };
        collabEditProvider.on('metadata:changed', handleTitleChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleTitleChanged);
        };
    }, [
        collabEditProvider,
        onMetadataChange,
        isLivePage,
        isRovoLLMEnabled,
        isDocEmptyRef
    ]);
    return {
        onTitleChange: onTitleChange,
        title: title
    };
};



var $l1kdf = parcelRequire("l1kdf");





var $jbOus = parcelRequire("jbOus");














var $1iuay = parcelRequire("1iuay");

const $03a48f98bcaadc9f$var$isNotPermittedError = (error)=>{
    return error.code === (0, $jbOus.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR && 'EXPIRED_TOKEN' !== error.reason || error.code === (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND;
};
const $03a48f98bcaadc9f$var$isTenantSuspendedError = (error)=>error.status === 423;
/**
 * The document has been blocked (blacklisted) by NCS, e.g. via the documentari kill switch.
 * https://switcheroo.atlassian.com/ui/gates/1a5f36bd-0eb6-4634-ba32-ae325174edb8/key/documentari_kill_switch
 * This is an expected, non-recoverable precondition (not a failure), so we disconnect and abort rather than
 * fire an error/reconnect loop. The DOCUMENT_BLOCKED code is only ever emitted when
 * platform_editor_blocked_document_ux is on (gated in the collab-provider errorCodeMapper), so the code
 * alone is the reliable signal here.
 */ const $03a48f98bcaadc9f$var$isDocumentBlockedError = (error)=>error.code === (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_BLOCKED;
const $03a48f98bcaadc9f$export$5027865de34f9ec6 = (collabEditProvider, recover, contentId, contentType)=>{
    const [error, setError] = (0, $cozmU.useState)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentEditorPageLoadExperienceName = isLivePage ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    const setErrorAndDisconnect = (0, $cozmU.useCallback)((newError)=>{
        if ($03a48f98bcaadc9f$var$isDocumentBlockedError(newError)) {
            // Document is blocked (blacklisted). Surface the error so the UI can show a blocked
            // message, stop the provider from reconnecting, and abort (not fail) the load
            // experience so the editor settles into a disabled state instead of spinning.
            setError(newError);
            collabEditProvider?.disconnect();
            const blockedExperienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
            if (blockedExperienceState && !blockedExperienceState.hasStopped) experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: 'document blocked',
                attributes: {
                    errorStatus: newError.status,
                    errorName: newError.code,
                    errorMessage: newError.message,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
            return;
        }
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError) || (0, $1iuay.isUnrecoverableError)(newError) || $03a48f98bcaadc9f$var$isTenantSuspendedError(newError)) setError(newError);
        const experienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
        if (!experienceState || experienceState.hasStopped) {
            // initialisation completed but we received an error later
            if (!$03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
                if ((0, $1iuay.isUnrecoverableError)(newError)) experienceTracker.stopOnError({
                    name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                    error: {
                        name: newError.code,
                        message: newError.message
                    },
                    attributes: {
                        errorStatus: newError.status,
                        objectId: contentId,
                        objectType: contentType,
                        isLivePage: isLivePage
                    }
                });
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'nativeEditor',
                        source: 'confluenceFrontend',
                        objectId: contentId,
                        objectType: contentType,
                        attributes: {
                            errorName: newError.code,
                            errorMessage: newError.message,
                            errorStatus: newError.status,
                            isRecoverable: true,
                            reason: 'reason' in newError ? newError.reason : 'unknown',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return;
        }
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
            // expected 403 for restricted page or deleted page
            // for deleted page, 403 is returned with reason "RESOURCE_DELETED"
            let newErrorReason;
            if ('reason' in newError) newErrorReason = newError.reason;
            collabEditProvider.disconnect();
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: newErrorReason ?? 'page restricted or deleted',
                attributes: {
                    errorStatus: newError.status,
                    errorName: newError.code,
                    errorMessage: newError.message,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
        } else if ((0, $1iuay.isUnrecoverableError)(newError)) // unhandled/unexpected errors
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: {
                name: newError.code,
                message: newError.message
            },
            attributes: {
                errorStatus: newError.status,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage
            }
        });
    }, [
        collabEditProvider,
        experienceTracker,
        createAnalyticsEvent,
        contentId,
        contentType,
        currentEditorPageLoadExperienceName,
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleError = (emittedError)=>{
            if (emittedError.status == 404) // 404 means that collab service doesn't have the document but Confluence does
            // Reset the document before displaying an error (creates it in NCS if missing).
            recover();
            else setErrorAndDisconnect(emittedError);
        };
        collabEditProvider.on('error', handleError);
        return ()=>{
            collabEditProvider.off('error', handleError);
        };
    }, [
        collabEditProvider,
        recover,
        setErrorAndDisconnect
    ]);
    return {
        error: error
    };
};






var $422HI = parcelRequire("422HI");


var $bMmYR = parcelRequire("bMmYR");











var $aMcHK = parcelRequire("aMcHK");


var $fJlJm = parcelRequire("fJlJm");







const $2349fbb443dc34e1$var$getStatusCodeFromApolloError = (error)=>{
    return (0, $422HI.isApolloError)(error) && (0, $hBkCm.BadStatusError).isBadStatusError(error?.graphQLErrors?.[0]?.originalError) ? Number((0, $aMcHK.getStatusCodeError)(error.graphQLErrors[0].originalError)) : null;
};
const $2349fbb443dc34e1$export$37716993b089624 = (resetCollabService, contentId, contentType)=>{
    const [recoveryError, setRecoveryError] = (0, $cozmU.useState)(null);
    const hasResetRef = (0, $cozmU.useRef)({
        active: true,
        resetInProgress: false,
        resetCount: 0
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentEditorPageLoadExperienceName = isLivePage ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    (0, $cozmU.useEffect)(()=>{
        // Live doc navigation can change the document without unmounting this hook.
        const recoveryState = {
            active: true,
            resetInProgress: false,
            resetCount: 0
        };
        hasResetRef.current = recoveryState;
        setRecoveryError(null);
        return ()=>{
            recoveryState.active = false;
        };
    }, [
        contentId
    ]);
    const stopExperienceOnRecoveryError = (0, $cozmU.useCallback)((recoveryErrorForAnalytics)=>{
        if (!!recoveryErrorForAnalytics?.status && recoveryErrorForAnalytics?.status < 500) {
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: `Recovery failed with error status ${recoveryErrorForAnalytics.status}`,
                attributes: {
                    errorStatus: recoveryErrorForAnalytics?.status,
                    traceId: recoveryErrorForAnalytics?.traceId,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
            return;
        }
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: recoveryErrorForAnalytics,
            attributes: {
                ...recoveryErrorForAnalytics?.status ? {
                    errorStatus: recoveryErrorForAnalytics.status
                } : {},
                errorType: 'Recovery failed',
                traceId: recoveryErrorForAnalytics?.traceId,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage
            }
        });
    }, [
        contentId,
        contentType,
        experienceTracker,
        currentEditorPageLoadExperienceName,
        isLivePage
    ]);
    const recover = (0, $cozmU.useCallback)(async ()=>{
        const recoveryState = hasResetRef.current;
        if (!recoveryState.active || recoveryState.resetInProgress) return;
        else if (recoveryState.resetCount > 0) {
            // Recovery has already been attempted, but NCS still requires recovery.
            const error = new (0, $1iuay.CollabRecoveryErrorType)(`Collab recovery unsuccessful`);
            setRecoveryError(error);
            stopExperienceOnRecoveryError(error);
            return;
        }
        recoveryState.resetInProgress = true;
        recoveryState.resetCount += 1;
        const shouldRetryPredicate = async (error)=>{
            const statusCode = $2349fbb443dc34e1$var$getStatusCodeFromApolloError(error);
            return recoveryState.active && !!statusCode && statusCode >= 500;
        };
        try {
            await (0, $bMmYR.retry)(async ()=>{
                // Navigation can happen during the retry delay, after the predicate was checked.
                if (recoveryState.active) return resetCollabService();
            }, {
                maxAttempts: 2,
                timeout: 2000
            }, shouldRetryPredicate);
            recoveryState.resetInProgress = false;
        } catch (e) {
            if (!recoveryState.active) return;
            // page recovery has failed, editor is empty... fatal error
            let recoveryError = e; // "public" error used by other components
            const statusCode = $2349fbb443dc34e1$var$getStatusCodeFromApolloError(e);
            if (!!statusCode) recoveryError = new (0, $1iuay.CollabRecoveryErrorType)(`Collab recovery responded with ${statusCode}`, statusCode, (0, $fJlJm.getTraceIdFromApolloError)(e) ?? undefined);
            setRecoveryError(recoveryError);
            stopExperienceOnRecoveryError(recoveryError);
            recoveryState.resetInProgress = false;
        }
    }, [
        resetCollabService,
        stopExperienceOnRecoveryError
    ]);
    return {
        recover: recover,
        recoveryError: recoveryError
    };
};





const $aa4c9ab1d5729ef5$export$e58f482756e84ff = (collabEditProvider, recover)=>{
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleRecoveryRequired = ()=>{
            recover();
        };
        collabEditProvider.on('recovery:required', handleRecoveryRequired);
        return ()=>{
            collabEditProvider.off('recovery:required', handleRecoveryRequired);
        };
    }, [
        collabEditProvider,
        recover
    ]);
};









var $cMvQV = parcelRequire("cMvQV");


var $1xpoY = parcelRequire("1xpoY");








var $kM55L = parcelRequire("kM55L");

const $9864520a4290ae17$export$db1accf726e7c589 = (collabEditProvider, contentId, contentType)=>{
    // we have been disconnected for confluence_frontend_ncs_disconnected_delay_ms time,
    // assume internet is lost which will result in disabling editor
    const [internetLost, setInternetLost] = (0, $cozmU.useState)(false);
    const [disconnected, setDisconnected] = (0, $cozmU.useState)(false);
    const networkStatusActions = (0, $kM55L.useCollabNetworkStatusActions)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // disconnected ref holds the latest socket disconnected status
    const disconnectRef = (0, $cozmU.useRef)(false);
    // data for analytics
    const collabSessionIdRef = (0, $cozmU.useRef)();
    const lastDisconnectedTime = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // wait period to allow socket.io (collab provider) to try to reconnect once before we declare internet as lost
    // socket.io has a default reconnection delay which is random time between a min and max, we need to wait at least as the max reconnection delay
    // https://socket.io/docs/v3/client-initialization/#reconnectionDelay
    const DISCONNECTED_DELAY_MS = Number((0, $1xpoY.default).getNumber('confluence_frontend_ncs_disconnected_delay_ms', 0)); // default to 0 if FF not set, meaning we don't wait to confirm disconnection
    const triggerAnalyticsEvent = (0, $cozmU.useCallback)(// prettier-ignore
    ({ trigger: trigger, attributes: attributes })=>{
        createAnalyticsEvent({
            type: "sendOperationalEvent",
            data: {
                action: trigger,
                actionSubject: "nativeEditor",
                source: "confluenceFrontend",
                objectId: contentId,
                objectType: contentType,
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleDisconnected = ({ reason: reason })=>{
            if (reason === 'SOCKET_CLOSED' || reason === 'SOCKET_ERROR') {
                triggerAnalyticsEvent({
                    trigger: 'disconnected',
                    attributes: {
                        collabSessionId: collabSessionIdRef.current,
                        reason: reason,
                        time: Date.now(),
                        online: navigator.onLine
                    }
                });
                disconnectRef.current = true;
                lastDisconnectedTime.current = Date.now(); // used for analytics
                // if disconnected delay is 0, then we don't do anything with the timeout and immediately report internet lost
                if (DISCONNECTED_DELAY_MS == 0) {
                    setInternetLost(true);
                    networkStatusActions.setIsCollabOffline(true);
                    return;
                }
                // else disconnected delay is set, so wait until confirming internet is lost
                setTimeout(()=>{
                    if (disconnectRef.current) {
                        // still disconnected after wait period, persist it and notify hook caller
                        setInternetLost(true);
                        networkStatusActions.setIsCollabOffline(true);
                    }
                }, DISCONNECTED_DELAY_MS);
            } else setDisconnected(true);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                message: 'NCS Disconnected',
                attributes: {
                    reason: reason
                }
            });
        };
        const handleReconnected = ({ sid: sid })=>{
            if (disconnectRef.current) {
                // only fire reconnected event when we have already disconnected
                (0, $cMvQV.setUserAgent)();
                triggerAnalyticsEvent({
                    trigger: 'reconnected',
                    attributes: {
                        collabSessionId: collabSessionIdRef.current,
                        disconnectedTimeMs: Date.now() - lastDisconnectedTime.current,
                        time: Date.now(),
                        browser: (0, $cMvQV.friendlyName)(),
                        browserVersion: (0, $cMvQV.version)(),
                        online: navigator.onLine
                    }
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                    message: 'NCS Reconnected'
                });
            }
            collabSessionIdRef.current = sid;
            disconnectRef.current = false;
            setInternetLost(false);
            setDisconnected(false);
            networkStatusActions.setIsCollabOffline(false);
        };
        collabEditProvider.on('disconnected', handleDisconnected);
        collabEditProvider.on('connected', handleReconnected);
        return ()=>{
            collabEditProvider.off('disconnected', handleDisconnected);
            collabEditProvider.off('connected', handleReconnected);
        };
    }, [
        collabEditProvider,
        triggerAnalyticsEvent,
        DISCONNECTED_DELAY_MS,
        experienceTracker,
        networkStatusActions
    ]);
    return {
        internetLost: internetLost,
        disconnected: disconnected
    };
};

















const $9d85f7d3eca95b9f$export$8454ade539132f7e = (collabEditProvider, contentId, contentType)=>{
    const COLLAB_STEP_FAILURE_LIMIT = 150;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showEditorFlag: showEditorFlag } = (0, $dYcT6.useEditorFlagsContext)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // tracking the number of consecutive step failures
    const stepFailureCount = (0, $cozmU.useRef)(0);
    const [hasExceededMaxStepFailures, setHasExceededMaxStepFailures] = (0, $cozmU.useState)(false);
    const prevContentId = (0, $cozmU.useRef)(contentId);
    // stepFailureCount is specific to the current contentId. If we're on a different contentId, reset stepFailureCount.
    (0, $cozmU.useEffect)(()=>{
        if (contentId !== prevContentId.current) {
            stepFailureCount.current = 0;
            setHasExceededMaxStepFailures(false);
            prevContentId.current = contentId;
        }
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleCommitStatus = ({ status: status, version: version })=>{
            if (!COLLAB_STEP_FAILURE_LIMIT) return; // only track failures/show flag for non-zero limit
            // `attempt` will either result in `success` or `failure`
            if (status === 'failure') {
                stepFailureCount.current++;
                if (!hasExceededMaxStepFailures && stepFailureCount.current > COLLAB_STEP_FAILURE_LIMIT) {
                    setHasExceededMaxStepFailures(true);
                    showEditorFlag({
                        errorName: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_STATUS_ERROR
                    });
                    // reset consecutive failure count
                    stepFailureCount.current = 0;
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'stepFailureLimitExceeded',
                            actionSubject: 'nativeEditor',
                            source: 'confluenceFrontend',
                            objectId: contentId,
                            objectType: contentType,
                            attributes: {
                                version: version
                            }
                        }
                    }).fire();
                }
            } else if (status === 'success') {
                // reset consecutive failure count
                stepFailureCount.current = 0;
                setHasExceededMaxStepFailures(false);
            }
        };
        collabEditProvider.on('commit-status', handleCommitStatus);
        return ()=>{
            collabEditProvider.off('commit-status', handleCommitStatus);
        };
    }, [
        collabEditProvider,
        COLLAB_STEP_FAILURE_LIMIT,
        contentId,
        contentType,
        createAnalyticsEvent,
        showEditorFlag,
        isLivePage,
        hasExceededMaxStepFailures
    ]);
    return {
        hasExceededMaxStepFailures: hasExceededMaxStepFailures,
        stepFailureCount: stepFailureCount.current
    };
};



var $9ohnn = parcelRequire("9ohnn");


var $2wSyg = parcelRequire("2wSyg");

























const $d48fd7abf8dd0296$export$d6b5f8c06e98c538 = ({ contentId: contentId, contentType: contentType, collabEditInitialized: collabEditInitialized, collabRecoveryError: collabRecoveryError, collabEditError: collabEditError, isEditPageDraftRestricted: isEditPageDraftRestricted })=>{
    const [collabInitTimedOut, setCollabInitTimedOut] = (0, $cozmU.useState)(false);
    const { showEditorFlag: showEditorFlag } = (0, $dYcT6.useEditorFlagsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const COLLAB_INIT_TIMEOUT_MS = (0, $1xpoY.default).getNumber('confluence_frontend_set_collab_init_timeout', 0); // default to 0 if FF not set, meaning we don't wait to show the flag
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const prevContentId = (0, $cozmU.useRef)(contentId);
    (0, $cozmU.useEffect)(()=>{
        if (contentId !== prevContentId.current) {
            // Short circuit on contentId mismatch
            prevContentId.current = contentId;
            setCollabInitTimedOut(false);
            return;
        }
        // short-circuit when:
        //      * new collab service is already initialized
        //      * COLLAB_INIT_TIMEOUT_MS has not been set
        //      * collabRecoveryError is defined (as we display a distinct flag for recovery error)
        //      * collabEditError unrecoverable or permission/not found error received over websocket, we have separate error handling code paths
        if (collabEditInitialized || COLLAB_INIT_TIMEOUT_MS === 0 || collabRecoveryError || collabEditError || isEditPageDraftRestricted) {
            setCollabInitTimedOut(false);
            return;
        }
        const timeout = setTimeout(()=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'editorLoadTimeout',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        timeoutMs: COLLAB_INIT_TIMEOUT_MS,
                        edition: edition
                    }
                }
            }).fire();
            showEditorFlag({
                errorName: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG
            });
            experienceTracker.attachDebugPoint({
                name: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG,
                message: `NCS Connect Timeout after ${COLLAB_INIT_TIMEOUT_MS}`
            });
            setCollabInitTimedOut(true);
        }, COLLAB_INIT_TIMEOUT_MS);
        return ()=>{
            clearTimeout(timeout);
            setCollabInitTimedOut(false);
        };
    }, [
        collabEditInitialized,
        collabRecoveryError,
        collabEditError,
        contentId,
        contentType,
        edition,
        COLLAB_INIT_TIMEOUT_MS,
        showEditorFlag,
        createAnalyticsEvent,
        isEditPageDraftRestricted,
        experienceTracker
    ]);
    return {
        collabInitTimedOut: collabInitTimedOut
    };
};





const $3d2bdad8a6d8f3a9$export$7f2f16f07012ca31 = (collabEditInitialized, isCollabProviderConnected, onConnectionTimedOut)=>{
    const COLLAB_CONNECTED_TIMEOUT_MS = 10000; // 10 second timeout
    const [collabEditConnectionTimedOut, setCollabEditConnectionTimedOut] = (0, $cozmU.useState)(false);
    const onConnectionTimedOutRef = (0, $cozmU.useRef)(undefined);
    onConnectionTimedOutRef.current = onConnectionTimedOut;
    (0, $cozmU.useEffect)(()=>{
        // short-circuit when new collab service is already initialized, COLLAB_INIT_TIMEOUT_MS has not been set
        // if collab provider is connected after X seconds we don't want to show the banner anymore
        if (!collabEditInitialized) return;
        if (isCollabProviderConnected) {
            setCollabEditConnectionTimedOut(false);
            return;
        }
        const timeout = setTimeout(()=>{
            setCollabEditConnectionTimedOut(true);
            onConnectionTimedOutRef.current?.();
        }, COLLAB_CONNECTED_TIMEOUT_MS);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        isCollabProviderConnected,
        collabEditInitialized,
        COLLAB_CONNECTED_TIMEOUT_MS
    ]);
    return {
        collabEditConnectionTimedOut: collabEditConnectionTimedOut
    };
};



var $1sAC2 = parcelRequire("1sAC2");











var $de2j9 = parcelRequire("de2j9");

const $db128acae7ce7c78$export$669363b9b30c636b = (contentId, data, isUnpublishedDraft)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [eventFired, setEventFired] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    (0, $cozmU.useEffect)(()=>{
        // Short circuit if any of the following are true:
        // The contentId is falsey.
        // The event has already been fired.
        // The page has been published before.
        if (!contentId || eventFired || !isUnpublishedDraft) return;
        const content = data?.content?.nodes?.[0];
        // If the content is not a draft, then short circit. The status
        // should only be "draft" if it's an unpublished draft since the
        // query would've returned the "current" version otherwise. In a
        // way, this may be redundant since we're checking isUnpublishedDraft,
        // but the logic to determine that is different.
        if (content?.status !== 'draft') return;
        // On a brand new draft, the NCS step version should be "1".
        // If it's an unpublished draft and the step version is > 1,
        // then it's very likely the event has already been fired.
        if (content?.version?.ncsStepVersion !== '1') return;
        // Get the account ID of the user who created the draft.
        // Note that this can change if another user edits the draft.
        // However, the NCS step version would likely change in that
        // case, so this check should prevent anyone but the draft
        // creator from firing the event.
        let accountId;
        const byData = content?.version?.by;
        if (byData && 'accountId' in byData) accountId = byData.accountId ?? undefined;
        const isDraftCreator = accountId && accountId === userId;
        // The current user is not the one who created the draft (e.g., it was shared with them).
        if (!isDraftCreator) return;
        // NB: It's definitely possible that this event could be fired
        // multiple times. This could happen if the creator returns to an
        // unpublished draft that has never been edited (e.g., create a
        // draft and then refresh the page). This has been discussed and
        // deemed acceptable in the following thread:
        // https://atlassian.slack.com/archives/CFGRZK3MF/p1695245508398199
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'created',
                actionSubject: 'draft',
                source: 'nativeCollabComponent',
                objectId: contentId,
                attributes: {
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
        setEventFired(true);
    }, [
        data,
        isUnpublishedDraft,
        userId,
        eventFired,
        contentId,
        createAnalyticsEvent,
        isOnEditRoute
    ]);
};








const $aff25131b393e2be$export$dec2596f28c74910 = ({ collabEditProvider: collabEditProvider, onPermissionChange: onPermissionChange })=>{
    const permissionDataRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handlePermissionChange = (permissionData)=>{
            if (permissionDataRef.current != null && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(permissionDataRef.current, permissionData)) // Passing the permission data to the callback would lead to a performance optimisation,
            // preventing refetching the permissions via a network request in LivePageComponent.
            onPermissionChange?.();
            permissionDataRef.current = permissionData;
        };
        collabEditProvider.on('permission', handlePermissionChange);
        return ()=>{
            collabEditProvider.off('permission', handlePermissionChange);
        };
    }, [
        collabEditProvider,
        onPermissionChange
    ]);
};






var $kSwu1 = parcelRequire("kSwu1");







const $7de34ad88b50619a$var$i18n = (0, $kSwu1.defineMessages)({
    titleKeywordForAutomationDiscovery: {
        id: "native-collab.title-keyword-for-automation-discovery.",
        defaultMessage: "meeting"
    },
    // Collaborative editing limits, notification flag
    collabLimitReachedTitle: {
        id: "native-collab.collab-limit-reached-title",
        defaultMessage: "You can\u2019t edit this content right now"
    },
    collabLimitReachedDescription: {
        id: "native-collab.collab-limit-reached-description",
        defaultMessage: "You\u2019ve reached the max number of active editors. Try again when it\u2019s not so busy."
    },
    underCollabLimitTitle: {
        id: "native-collab.collab.under.collab-limit-title",
        defaultMessage: "Ready to go"
    },
    underCollabLimitDescription: {
        id: "native-collab.collab.under.collab-limit-description",
        defaultMessage: "We\u2019re autosaving your changes, so you never need to press save."
    },
    // Live pages view mode limits
    livePagesViewLimitReachedTitle: {
        id: "native-collab.live-pages-limit-reached-title",
        defaultMessage: "This content can\u2019t be viewed right now. Reload and try again."
    },
    livePagesViewLimitReachedDescription: {
        id: "native-collab.live-pages-limit-reached-description",
        defaultMessage: "You\u2019ve reached the max number of active viewers. Try again when it\u2019s not so busy."
    },
    underLivePagesViewLimitTitle: {
        id: "native-collab.live-pages.under.live-pages-limit-title",
        defaultMessage: "Ready to go"
    }
});
const $7de34ad88b50619a$export$b543849fd09fd533 = ({ contentId: contentId, spaceId: spaceId, flags: flags, isEditLimitExceeded: isEditLimitExceeded, collabEditProvider: // flag will be shown indicating that too many participants are editing
collabEditProvider, isLiveViewLimitExceeded: isLiveViewLimitExceeded = false // triggers static fallback view mode where editor will show content but be disconnected from NCS
 })=>{
    // To prevent the success message from showing on mount, we can use a ref to store if the user was previously at the collab limit or not
    const hasShownEditLimitFlag = (0, $cozmU.useRef)(false);
    const hasShownLiveViewLimitFlag = (0, $cozmU.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendLimitReachedEvent = (0, $cozmU.useCallback)(({ limitType: limitType })=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'collabLimitReached',
                actionSubject: 'editor',
                actionSubjectId: contentId,
                source: 'nativeEditor',
                objectId: contentId,
                containerId: spaceId,
                attributes: {
                    isLivePage: isLivePage,
                    limitType: limitType
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        spaceId,
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isEditLimitExceeded && !hasShownEditLimitFlag.current) sendLimitReachedEvent({
            limitType: 'EDIT'
        });
        if (isEditLimitExceeded && !hasShownEditLimitFlag.current) {
            // set the ref to true and display the error message
            // to notify the user they cannot edit
            hasShownEditLimitFlag.current = true;
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7de34ad88b50619a$var$i18n.collabLimitReachedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7de34ad88b50619a$var$i18n.collabLimitReachedDescription)
            });
        } else if (hasShownEditLimitFlag.current) {
            // reset the ref to false and show the success message
            // to notify the user they can edit again
            hasShownEditLimitFlag.current = false;
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7de34ad88b50619a$var$i18n.underCollabLimitTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7de34ad88b50619a$var$i18n.underCollabLimitDescription)
            });
        }
    }, [
        isEditLimitExceeded,
        flags,
        sendLimitReachedEvent,
        isLiveViewLimitExceeded
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage) return;
        if (isLiveViewLimitExceeded && !hasShownLiveViewLimitFlag.current) sendLimitReachedEvent({
            limitType: 'VIEW'
        });
        if (isLiveViewLimitExceeded) {
            collabEditProvider?.destroy();
            hasShownLiveViewLimitFlag.current = true;
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7de34ad88b50619a$var$i18n.livePagesViewLimitReachedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7de34ad88b50619a$var$i18n.livePagesViewLimitReachedDescription)
            });
        }
    }, [
        isLiveViewLimitExceeded,
        flags,
        isLivePage,
        collabEditProvider,
        sendLimitReachedEvent
    ]);
};



var $2VZOl = parcelRequire("2VZOl");




const $16ff2e8ae3ffbb2b$export$2074317a3e49860c = (collabEditProvider, onNamespaceLockCheck)=>{
    const [isLocked, setIsLocked] = (0, $cozmU.useState)(false);
    const namespaceLockCheckRef = (0, $cozmU.useRef)(null);
    const handleNamespaceLockCheck = (0, $cozmU.useCallback)((namespaceLockCheckData)=>{
        if (collabEditProvider) {
            namespaceLockCheckRef.current = namespaceLockCheckData;
            const namespaceIsLocked = namespaceLockCheckData.isLocked;
            setIsLocked(namespaceIsLocked);
            onNamespaceLockCheck?.(namespaceIsLocked);
        }
    }, [
        collabEditProvider,
        onNamespaceLockCheck
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('namespace-lock:check', handleNamespaceLockCheck);
        return ()=>{
            collabEditProvider.off('namespace-lock:check', handleNamespaceLockCheck);
        };
    }, [
        collabEditProvider,
        handleNamespaceLockCheck
    ]);
    return {
        isLocked: isLocked
    };
};















var $ikfiQ = parcelRequire("ikfiQ");

const $ba59f696f3dc8177$export$3f1b0247b5d1cf38 = ({ collabEditConnectionTimedOut: collabEditConnectionTimedOut, collabInitTimedOut: collabInitTimedOut })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const networkStatus = (0, $ikfiQ.useNetworkStatusListenerCache)();
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_analytics_on_ncs_disconnect')) return;
        const networkOffline = networkStatus === (0, $ikfiQ.ClientNetworkStatus).IP_BLOCKED || networkStatus === (0, $ikfiQ.ClientNetworkStatus).OFFLINE;
        const isCollabDisconnected = collabEditConnectionTimedOut || collabInitTimedOut;
        if (!networkOffline && isCollabDisconnected) // If NCS times out, but user is still connected to network
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'nativeCollabComponent',
                actionSubject: 'nativeCollabConnectionListener',
                actionSubjectId: 'nativeCollabConnectionListener',
                action: 'disconnected',
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        networkStatus,
        collabEditConnectionTimedOut,
        isLivePage,
        collabInitTimedOut,
        createAnalyticsEvent
    ]);
};


const $8e6a969f9ce0b73d$var$getDraftMetadata = (data, loading, draftShareId)=>{
    const content = data?.content?.nodes?.[0];
    return {
        // We use the presence of a draftShareId as a best guess for the isUnpublishedDraft value while this query is loading.
        isUnpublishedDraft: loading ? !!draftShareId : !content?.history?.createdBy,
        version: content?.version?.number || 1,
        spaceId: content?.space?.id || null,
        subType: content?.subType || null,
        isOverviewPage: !!content && content.space?.homepageId === content.id
    };
};
const $8e6a969f9ce0b73d$var$childrenMemoized = (0, $dOBRD.default)((children, props)=>children(props), (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $8e6a969f9ce0b73d$var$NativeCollabComponentClass = (props)=>{
    const { children: children, contentId: contentId, contentType: contentType, draftShareId: draftShareId, spaceKey: spaceKey, permissionTokenRefresh: permissionTokenRefresh, pageTreeStateUpdater: pageTreeStateUpdater, onPermissionChange: onPermissionChange, flags: flags, canEdit: canEdit } = props;
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { cloudId: cloudId, userId: userId, activationId: activationId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { getIsPublishing: getIsPublishing } = (0, $2wSyg.useDraftSyncAndPublishContext)();
    const [{ collabEditProvider: collabEditProvider }, { setCollabEditProvider: setCollabEditProvider, resetNativeCollabState: resetNativeCollabState }] = (0, $hYoU4.useNativeCollabState)();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const [forceDisabled, setForceDisabled] = (0, $cozmU.useState)(false);
    const lastPublishedVersionRef = (0, $cozmU.useRef)(null);
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const { client: fetchUsersClient } = (0, $j7xMJ.useFetchUsersClient)();
    const [nativeCollabQueryResult, setNativeCollabQueryResult] = (0, $cozmU.useState)(undefined);
    const { loading: loading, error: error, data: data } = {
        loading: nativeCollabQueryResult?.loading ?? true,
        error: nativeCollabQueryResult?.error,
        data: nativeCollabQueryResult?.data
    };
    const fetchNativeCollab = (0, $cozmU.useCallback)(async (shouldCheckCache)=>{
        // Fetch the editor draft metadata
        const queryResult = await (0, $c0rhi.queryInterop)({
            query: (0, $l1kdf.NativeCollabQuery),
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ],
                draftShareId: draftShareId
            },
            fetchPolicy: shouldCheckCache ? 'cache-first' : 'network-only',
            __callerPackage__: "native-collab"
        });
        // Sometimes, Apollo fetches data from the cache but returns an empty result.
        // In these situations, the code below will refetch the latest data from the server.
        //
        // This can happen when archiving a page, unarchiving it, and entering the editor in the same SPA session.
        // The NativeCollabQuery result is still in the GraphQL cache, so Apollo attempts to fetch it from the cache.
        // But for some reason it fails, and it returns an empty result.
        // This empty result can cause bugs in the editor, like an incorrect isUnpublishedDraft value.
        // I believe this may be a bug in Apollo.
        if (shouldCheckCache && Array.isArray(queryResult?.data?.content?.nodes) && queryResult?.data?.content?.nodes.length === 0) return await fetchNativeCollab(false);
        setNativeCollabQueryResult({
            ...queryResult,
            loading: false
        });
        return queryResult?.data;
    }, [
        contentId,
        draftShareId
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchNativeCollab(true);
    }, [
        fetchNativeCollab
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLivePage || nativeCollabQueryResult?.loading || nativeCollabQueryResult?.error) return;
        const contentNode = nativeCollabQueryResult?.data?.content?.nodes?.[0];
        const fetchedContentType = contentNode?.type;
        // only handle this for pages or blogposts to be safe
        const isValidType = fetchedContentType === 'page' || fetchedContentType === 'blogpost';
        if (!isValidType || fetchedContentType === contentType) return;
        const redirectRoute = fetchedContentType === 'page' ? (0, $1NBp8.EDIT_PAGE_V2) : (0, $1NBp8.EDIT_BLOG_V2);
        replace(redirectRoute.toUrl({
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: fetchedContentType === 'page' ? 'pages' : 'blog'
        }));
    }, [
        nativeCollabQueryResult,
        contentType,
        spaceKey,
        contentId,
        replace,
        isLivePage
    ]);
    const [resetCollabService] = (0, $ed9855f47d383028$export$5db3a73aad04cdb9)({
        variables: {
            behind: 'COLLAB',
            contentId: contentId
        }
    });
    const resetCurrentDocument = (0, $cozmU.useCallback)(()=>resetCollabService({
            variables: {
                behind: 'COLLAB',
                contentId: contentId
            }
        }), [
        contentId,
        resetCollabService
    ]);
    const memoizedDraftMetadata = (0, $cozmU.useMemo)(()=>$8e6a969f9ce0b73d$var$getDraftMetadata(data, loading, draftShareId), [
        data,
        loading,
        draftShareId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // clean-up for Native collab provider state when component unmounts
    (0, $cozmU.useEffect)(()=>{
        const sendEditTrackEvent = (action, exitedConfluence)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: action,
                    actionSubject: 'nativeEditor',
                    // "editor mounted" is taken
                    source: 'nativeCollabComponent',
                    attributes: {
                        exitedConfluence: exitedConfluence,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        const onBeforeUnload = ()=>{
            sendEditTrackEvent('closed', true);
        };
        sendEditTrackEvent('opened');
        window.addEventListener('beforeunload', onBeforeUnload);
        return ()=>{
            sendEditTrackEvent('closed');
            window.removeEventListener('beforeunload', onBeforeUnload);
            const transitionPreloaderCurrentCallbackIDs = (0, $ek3aD.getGlobalTransitionPreloader)().getCurrentRouteCallbackIds();
            const isSeamlessTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionPreloaderCurrentCallbackIDs.includes('live_doc_preloading_transition_callback_id') : false;
            if (!isSeamlessTransition) {
                resetNativeCollabState();
                (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { preloadedDraftPromise: preloadedDraftPromise } = (0, $3939153f8cab4d4a$export$6af0fd9cc35e7328)(contentId);
    const [{ isViewMode: isViewMode, mode: mode }, { setMode: setMode }] = (0, $efvKr.useLivePageMode)();
    // At client-side rendering, while waiting for mode to have data, initialize it with canEdit
    // if it's available from SSRed result
    const initialViewMode = mode === undefined && canEdit !== undefined ? !canEdit : isViewMode;
    (0, $cozmU.useEffect)(()=>{
        // Live Docs rely on useIsEditorDataLoader to set collab edit provider
        if (isLivePage) return;
        const activity = initialViewMode ? 'viewer' : 'editor';
        preloadedDraftPromise.then((preloadedDraft)=>{
            // getCollabEditProvider call getAnalyticsWebClient and return a Promise with collabEditProvider
            // and analyticsClient passed in as argument
            // DO NOT add any asynchronous calls/behavior to the collab provider creation. This has caused incidents
            // in the past where the provider promise never resolves and editing breaks.
            // Context: https://hello.atlassian.net/wiki/spaces/~589311246/pages/2554442259/Investigate+async+issue+HOT-103180
            const provider = (0, $fWGpT.getCollabEditProvider)({
                contentId: contentId,
                cloudId: cloudId,
                activationId: activationId,
                contentType: contentType,
                permissionTokenRefresh: permissionTokenRefresh,
                initialDraft: preloadedDraft,
                isLivePage: isLivePage,
                presenceId: presenceId,
                presenceActivity: activity,
                userId: userId,
                fetchUsersClient: fetchUsersClient
            });
            setCollabEditProvider(provider);
            // marking provider creation
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CREATED);
            // at this point, provider has been created but is not yet initialized
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_DISABLED);
            // marking post-creation -> pre-connection time
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRE_CONNECTED);
        });
    }, [
        activationId,
        cloudId,
        contentId,
        contentType,
        initialViewMode,
        isLivePage,
        presenceId,
        userId,
        permissionTokenRefresh,
        preloadedDraftPromise,
        setCollabEditProvider,
        fetchUsersClient
    ]);
    // Clean-up
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Explicitly call destroy so the disconnect happens
            const transitionPreloaderCurrentCallbackIDs = (0, $ek3aD.getGlobalTransitionPreloader)().getCurrentRouteCallbackIds();
            const isSeamlessTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionPreloaderCurrentCallbackIDs.includes('live_doc_preloading_transition_callback_id') : false;
            if (collabEditProvider && !isSeamlessTransition) {
                collabEditProvider?.destroy();
                // Clear the memoized function. If the user goes back to editing the same page,
                // then we don't run into problem trying to talk to the old (destroyed) collab provider.
                if ((0, $fWGpT.getCollabEditProvider).cache?.clear) (0, $fWGpT.getCollabEditProvider).cache.clear();
            }
        };
    }, [
        collabEditProvider
    ]);
    // Collab native events
    const { collabEditInitialized: collabEditInitialized, titleFromInit: titleFromInit, isDocEmptyRef: isDocEmptyRef } = (0, $6c2bcd900cfaf680$export$e8232107184b2af1)(collabEditProvider, contentId, isCompanyHub, isRovoLLMEnabled);
    const handleMetadataChange = (0, $cozmU.useCallback)(()=>{
        if (contentType === 'blogpost') // update blog tree to show untitled blank blog draft after it is created
        forceRefetchBlogTree();
        // If we are on a live page, refresh the page tree so the new title is reflected in the page tree
        if (isLivePage) pageTreeStateUpdater?.setForceFetchPageId(contentId);
    }, [
        isLivePage,
        pageTreeStateUpdater,
        contentId,
        contentType,
        forceRefetchBlogTree
    ]);
    // Trigger `handleMetadataChange` wheneven a title changed event is received from NCS.
    const { onTitleChange: onTitleChange, title: title } = (0, $4cea9cbb27e2f2c9$export$e85f4ef42a672a12)(collabEditProvider, handleMetadataChange, isLivePage, isRovoLLMEnabled, isDocEmptyRef);
    // NOTE: The logic to refresh the PageTree on title emoji change is in EmojiTitleButton.ts
    // Trigger `handleNamespaceLockCheck` when `namespace-lock:check` event is emitted from NCS.
    const { isLocked: isLocked } = (0, $16ff2e8ae3ffbb2b$export$2074317a3e49860c)(collabEditProvider);
    const { isFirstParticipant: isFirstParticipant, isSingleUserSession: isSingleUserSession } = (0, $5M5fB.usePresence)(collabEditProvider);
    const { showEditorFlag: showEditorFlag } = (0, $dYcT6.useEditorFlagsContext)();
    const [isUnpublishedDraft, setIsUnpublishedDraft] = (0, $cozmU.useState)(memoizedDraftMetadata.isUnpublishedDraft);
    const [version, setVersion] = (0, $cozmU.useState)(memoizedDraftMetadata.version);
    const [subType, setSubtype] = (0, $cozmU.useState)(null);
    const [isOverviewPage, setIsOverviewPage] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsUnpublishedDraft(memoizedDraftMetadata.isUnpublishedDraft);
        setVersion(memoizedDraftMetadata.version);
        setSubtype(memoizedDraftMetadata.subType);
        setIsOverviewPage(memoizedDraftMetadata.isOverviewPage);
    }, [
        memoizedDraftMetadata.version,
        memoizedDraftMetadata.isUnpublishedDraft,
        memoizedDraftMetadata.subType,
        memoizedDraftMetadata.isOverviewPage
    ]);
    // Editor flag for when another user publishes the page
    const showPublishedFlagOnce = (0, $cozmU.useCallback)((newVersion, lastPublisherId)=>{
        if (lastPublisherId !== userId || isLivePage && !getIsPublishing()) {
            if (lastPublishedVersionRef.current === newVersion) // We don't want to show the flag if it's already been shown for this version
            return;
            // If the last publisher is not the current user, show the flag
            // On a live page, we'll always show the flag no matter who the last publisher is unless you are the one publishing on this tab.
            // The intent of the live pages flag showing for yourself is in case you have multiple tabs open and you publish on one of them.
            lastPublishedVersionRef.current = newVersion;
            showEditorFlag({
                errorName: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH,
                statusCode: newVersion,
                lastPublisher: lastPublisherId
            });
        }
    }, [
        getIsPublishing,
        isLivePage,
        showEditorFlag,
        userId
    ]);
    const onPublishedSubscriptionEvent = (0, $cozmU.useCallback)((newVersion, accountId)=>{
        if (!newVersion) return;
        setVersion(newVersion);
        setIsUnpublishedDraft(false);
        if (isLivePage) setForceDisabled(true);
        const lastPublisherId = accountId;
        showPublishedFlagOnce(newVersion, lastPublisherId);
    }, [
        isLivePage,
        showPublishedFlagOnce
    ]);
    // Editor flag for when another user restores the page to a previous version
    const onRestoreSubscriptionEvent = (0, $cozmU.useCallback)((accountId)=>{
        if (accountId !== userId) showEditorFlag({
            errorName: (0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE,
            lastPublisher: accountId
        });
    }, [
        showEditorFlag,
        userId
    ]);
    const onPageUpdatedSubscription = (0, $cozmU.useCallback)((response)=>{
        const { pageUpdated: pageUpdated, accountId: accountId } = response || {};
        const trigger = pageUpdated?.trigger;
        const confVersion = pageUpdated?.confVersion;
        if (trigger === 'convertToLiveEdit' && contentType === 'page') setForceDisabled(true);
        else if (trigger === 'restore') onRestoreSubscriptionEvent(accountId);
        else if (trigger === 'publish') onPublishedSubscriptionEvent(confVersion, accountId);
    }, [
        contentType,
        onPublishedSubscriptionEvent,
        onRestoreSubscriptionEvent
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'NativeCollabComponent',
        contentId: contentId,
        delta: 'pageUpdated',
        contentType: contentType,
        onDataReceived: onPageUpdatedSubscription
    });
    (0, $db128acae7ce7c78$export$669363b9b30c636b)(contentId, data, isUnpublishedDraft);
    // Collab unhappy path events
    const { recover: recover, recoveryError: collabRecoveryError } = (0, $2349fbb443dc34e1$export$37716993b089624)(resetCurrentDocument, contentId, contentType);
    const { error: collabEditError } = (0, $03a48f98bcaadc9f$export$5027865de34f9ec6)(collabEditProvider, recover, contentId, contentType);
    (0, $aa4c9ab1d5729ef5$export$e58f482756e84ff)(collabEditProvider, recover);
    const { internetLost: collabEditInternetLost, disconnected: disconnected } = (0, $9864520a4290ae17$export$db1accf726e7c589)(collabEditProvider, contentId, contentType);
    const { hasExceededMaxStepFailures: hasExceededMaxStepFailures } = (0, $9d85f7d3eca95b9f$export$8454ade539132f7e)(collabEditProvider, contentId, contentType);
    const { isCollabProviderConnected: isCollabProviderConnected } = (0, $9ohnn.useConnected)(collabEditProvider, contentId);
    const { collabEditConnectionTimedOut: collabEditConnectionTimedOut } = (0, $3d2bdad8a6d8f3a9$export$7f2f16f07012ca31)(collabEditInitialized, isCollabProviderConnected);
    const heartbeatData = (0, $5MyXJ.useEditorHeartbeat)({
        contentId: contentId,
        contentType: contentType,
        collabEditInitialized: collabEditInitialized,
        viewMode: initialViewMode
    });
    (0, $cozmU.useEffect)(()=>{
        if (isLivePage && heartbeatData.liveEditLimitReached) setMode('view');
    }, [
        isLivePage,
        heartbeatData.liveEditLimitReached,
        setMode
    ]);
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    (0, $cozmU.useEffect)(()=>{
        if (!heartbeatData.subtypeMismatch || !(0, $9wGTI.fg)('confluence_ncs_disconnect_idle_tabs_pubsub')) return;
        // If we detect subtypeMismatch===true, it means that the backend state is out of sync with the frontend.
        // This usually happens when this tab was idle. Since pubsub events are disabled on idle tabs,
        // this tab missed that change event and only discovered it through the heartbeat response
        const missedPageConvertedToLive = !isLivePage && heartbeatData.heartbeatSubtype === 'live';
        if (missedPageConvertedToLive) {
            // We thought this was a regular page, but the heartbeat shows it's now a live page
            // Need to disable editing since we're in an inconsistent state and show the convert-to-live flag
            setForceDisabled(true);
            showConvertToLivePageFlag({
                converterWasCurrentUser: false
            });
        }
        const missedLivePagePublished = isLivePage && heartbeatData.heartbeatSubtype === null;
        if (missedLivePagePublished) {
            // We thought this was still a live page, but the heartbeat shows it's been published
            // Need to disable editing since we're working with outdated page state and show the published flag
            setForceDisabled(true);
            showPublishedFlagOnce(version, userId);
        }
    }, [
        heartbeatData.heartbeatSubtype,
        heartbeatData.subtypeMismatch,
        isLivePage,
        showConvertToLivePageFlag,
        showPublishedFlagOnce,
        userId,
        version
    ]);
    const spaceId = (0, $7QM6o.useSpaceId)();
    (0, $aff25131b393e2be$export$dec2596f28c74910)({
        collabEditProvider: collabEditProvider,
        onPermissionChange: onPermissionChange
    });
    const { collabInitTimedOut: collabInitTimedOut } = (0, $d48fd7abf8dd0296$export$d6b5f8c06e98c538)({
        contentId: contentId,
        contentType: contentType,
        collabEditInitialized: collabEditInitialized,
        collabRecoveryError: collabRecoveryError,
        collabEditError: collabEditError,
        isEditPageDraftRestricted: (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'edit'
    });
    (0, $7de34ad88b50619a$export$b543849fd09fd533)({
        contentId: contentId,
        spaceId: spaceId,
        flags: flags,
        collabEditProvider: collabEditProvider,
        isEditLimitExceeded: heartbeatData.collabLimitReached || heartbeatData.liveEditLimitReached,
        isLiveViewLimitExceeded: heartbeatData.liveViewLimitReached
    });
    // analytics and experience tracking on NCS disconnection
    (0, $ba59f696f3dc8177$export$3f1b0247b5d1cf38)({
        collabEditConnectionTimedOut: collabEditConnectionTimedOut,
        collabInitTimedOut: collabInitTimedOut
    });
    // Editor expects collabEditProvider: Promise<CollabEditProvider> | undefined
    const collabEditProviderPromise = (0, $cozmU.useMemo)(()=>{
        return collabEditProvider ? Promise.resolve(collabEditProvider) : undefined;
    }, [
        collabEditProvider
    ]);
    // EDITOR-6492: stable per-mount clientID for prosemirror-collab, forwarded
    // via CollabEditOptions.userId. SSR-safe: never rendered to DOM.
    const [collabClientId] = (0, $cozmU.useState)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)) return undefined;
        const id = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : (0, $9HkI0.v4)();
        return `pc-${id}`;
    });
    const collabEditOption = (0, $cozmU.useMemo)(()=>{
        return {
            useNativePlugin: true,
            ...collabClientId && {
                userId: collabClientId
            }
        };
    }, [
        collabClientId
    ]);
    const collabEditStateOption = (0, $cozmU.useMemo)(()=>{
        return {
            collabEditInitialized: collabEditInitialized,
            collabEditError: collabEditError,
            collabEditInternetLost: collabEditInternetLost,
            collabRecoveryError: collabRecoveryError,
            collabEditConnectionTimedOut: collabEditConnectionTimedOut
        };
    }, [
        collabEditInitialized,
        collabEditError,
        collabEditInternetLost,
        collabRecoveryError,
        collabEditConnectionTimedOut
    ]);
    const internetDisconnected = (0, $cozmU.useMemo)(()=>disconnected, [
        disconnected
    ]);
    const onPublishUpdateTitleInPageTree = (0, $cozmU.useCallback)(()=>{
        // Company hub doesn't show the left nav / page tree so this is not necessary and, more importantly, it causes https://hello.atlassian.net/browse/CHUB-601
        if (!isCompanyHub) {
            if (contentType === 'blogpost') // force refetch blog tree when blogpost draft title changed on close or published with a new name
            forceRefetchBlogTree();
            else // otherwise, force refetch only the content tree
            pageTreeStateUpdater?.setForceFetchPageId(contentId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        isCompanyHub,
        contentType
    ]);
    const optimisticDeleteItemInTree = (0, $cozmU.useCallback)((id)=>{
        pageTreeStateUpdater?.setOptimisticDeleteId(id);
    }, [
        pageTreeStateUpdater
    ]);
    let currentEditorPageLoadExperienceName = (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    if (isLivePage) currentEditorPageLoadExperienceName = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    if (isCompanyHub) currentEditorPageLoadExperienceName = (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wSyg.DraftSyncAndPublishContextConsumer), null, ({ isPublishing: isPublishing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, $8e6a969f9ce0b73d$var$childrenMemoized(children, {
            contentId: contentId,
            draftShareId: draftShareId,
            spaceKey: spaceKey,
            spaceId: memoizedDraftMetadata.spaceId,
            // Editor related props
            disabled: !collabEditInitialized || loading || !!collabEditError || collabEditInternetLost || disconnected || forceDisabled || hasExceededMaxStepFailures || isPublishing || collabEditConnectionTimedOut || isLocked,
            setForceDisabled: setForceDisabled,
            internetDisconnected: internetDisconnected,
            forceDisabled: forceDisabled,
            // Collab related props
            collabEditProvider: collabEditProviderPromise,
            collabEdit: collabEditOption,
            collabEditState: collabEditStateOption,
            heartbeatData: heartbeatData,
            isFirstParticipant: isFirstParticipant,
            isSingleUserSession: isSingleUserSession,
            refetchNativeCollab: fetchNativeCollab,
            viewMode: isLivePage && initialViewMode,
            // Title related props
            // Note: title can be updated to an empty string
            title: title ?? titleFromInit,
            onTitleChange: onTitleChange,
            onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree,
            optimisticDeleteItemInTree: optimisticDeleteItemInTree,
            contentType: // Content query props
            contentType,
            isUnpublishedDraft: isUnpublishedDraft,
            version: version,
            subType: subType,
            isOverviewPage: isOverviewPage,
            createdDate: data?.content?.nodes?.[0]?.history?.createdDate
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
            name: currentEditorPageLoadExperienceName,
            error: collabRecoveryError || error,
            attributes: {
                collabService: 'ncs',
                isLivePage: isLivePage
            }
        })));
};
const $8e6a969f9ce0b73d$export$e4e0ed883908e7fe = (0, $7aRa9.withFlags)((0, $ecUYt.withPageTreeStateUpdater)((0, $dYcT6.withEditorFlagsContext)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wSyg.DraftSyncAndPublishContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e6a969f9ce0b73d$var$NativeCollabComponentClass, props)))));
module.exports["NativeCollabComponent"] = $8e6a969f9ce0b73d$export$e4e0ed883908e7fe;

});

parcelRegister("hjygH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("ecUYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("9o40q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("b4EKK", function(module, exports) {
function $9a7b0181c65e47f8$export$d882ca6820b0f4f3(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    return error;
}
module.exports["getErrorWithResponse"] = $9a7b0181c65e47f8$export$d882ca6820b0f4f3;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("jacyh", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false // this is just a boolean that we toggle between false and true to force a refetch in blog tree
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $8s9DV.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $kBr4q.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $kBr4q.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("1gh0Q", function(module, exports) {
/**
 * Regex to match the auto-generated live doc title format: "Untitled live doc YYYY-MM-DD"
 * or "Untitled live doc YYYY-MM-DD (n)" when multiple live docs are created on the same day.
 * This is the default title assigned by the backend when a new live doc is created.
 */ const $88fa25aefd5bae84$var$DEFAULT_LIVE_DOC_TITLE_PATTERN = /^Untitled live doc \d{4}-\d{2}-\d{2}( \(\d+\))?$/;
const $88fa25aefd5bae84$export$4926831772faf7e = (title)=>{
    if (!title) return false;
    return $88fa25aefd5bae84$var$DEFAULT_LIVE_DOC_TITLE_PATTERN.test(title);
};
module.exports["isDefaultLiveDocTitle"] = $88fa25aefd5bae84$export$4926831772faf7e;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("5M5fB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $cozmU.useRef)(null);
    const currentParticipants = (0, $cozmU.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $cozmU.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $cozmU.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $cozmU.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("9ohnn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hYoU4 = parcelRequire("hYoU4");


var $1sAC2 = parcelRequire("1sAC2");

const $173e9417c57854b2$export$2257bd3a33884363 = (collabEditProvider, contentId)=>{
    const [{ collabEditConnected: collabEditConnected }, nativeCollabActions] = (0, $hYoU4.useNativeCollabConnected)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = ()=>{
            nativeCollabActions.setCollabEditConnected(true);
            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
            // tracking time between when 'init' event is fired and connection has been established
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT_DOC);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                message: 'NCS Connected'
            });
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider,
        nativeCollabActions,
        contentId,
        experienceTracker
    ]);
    return {
        isCollabProviderConnected: collabEditConnected
    };
};
module.exports["useConnected"] = $173e9417c57854b2$export$2257bd3a33884363;

});

parcelRegister("2wSyg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7W8i8 = parcelRequire("7W8i8");

const $87bc0f5ac3c4b9fb$var$logger = (0, $7W8i8.getLogger)('native-collab');
const $87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsPublishing: ()=>false,
    setIsPublishing: (_)=>{
    // Intentional no-op
    },
    isPublishing: false,
    subscribeDraftSyncSuccess: ()=>()=>{},
    notifyDraftSyncSuccess: ()=>{}
});
const $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8 = ({ children: children })=>{
    // These should remain in sync. The ref is used while a draft sync occurs, while
    // the state variable is used for re-rendering.
    const isPublishingRef = (0, $cozmU.useRef)(false);
    const [isPublishing, setIsPublishing] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const draftSyncSuccessListeners = (0, $cozmU.useRef)(new Set());
    const subscribeDraftSyncSuccess = (0, $cozmU.useCallback)((listener)=>{
        draftSyncSuccessListeners.current.add(listener);
        return ()=>{
            draftSyncSuccessListeners.current.delete(listener);
        };
    }, []);
    const notifyDraftSyncSuccess = (0, $cozmU.useCallback)((contentId)=>{
        draftSyncSuccessListeners.current.forEach((listener)=>{
            try {
                listener(contentId);
            } catch (error) {
                // An observer failure must not turn a successful draft save into a sync error.
                $87bc0f5ac3c4b9fb$var$logger.error`Draft sync success listener failed: ${error}`;
            }
        });
    }, []);
    const getIsPublishing = (0, $cozmU.useCallback)(()=>isPublishingRef.current, []);
    const setPublishing = (0, $cozmU.useCallback)((value)=>{
        isPublishingRef.current = value;
        setIsPublishing(value);
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            getIsPublishing: getIsPublishing,
            setIsPublishing: setPublishing,
            isPublishing: isPublishing,
            subscribeDraftSyncSuccess: subscribeDraftSyncSuccess,
            notifyDraftSyncSuccess: notifyDraftSyncSuccess
        }), [
        getIsPublishing,
        setPublishing,
        isPublishing,
        subscribeDraftSyncSuccess,
        notifyDraftSyncSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext.Provider, {
        value: contextValue
    }, children);
};
const $87bc0f5ac3c4b9fb$export$bceb447197cf2e23 = ({ children: children })=>{
    const context = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4();
    return children(context);
};
const $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4 = ()=>{
    return (0, $cozmU.useContext)($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext);
};
module.exports["DraftSyncAndPublishContextProvider"] = $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8;
module.exports["DraftSyncAndPublishContextConsumer"] = $87bc0f5ac3c4b9fb$export$bceb447197cf2e23;
module.exports["useDraftSyncAndPublishContext"] = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("2VZOl", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $j8on0.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $8s9DV.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $kBr4q.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== appearance) {
        t3 = appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance);
        $[9] = appearance;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== appearance) {
        t4 = appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance);
        $[11] = appearance;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== target || $[19] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[18] = target;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== children || $[22] !== htmlAttributes || $[23] !== newWindowLabel || $[24] !== ref || $[25] !== t6 || $[26] !== t7 || $[27] !== target || $[28] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[21] = children;
        $[22] = htmlAttributes;
        $[23] = newWindowLabel;
        $[24] = ref;
        $[25] = t6;
        $[26] = t7;
        $[27] = target;
        $[28] = testId;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("aYr7p", function(module, exports) {

var $aQVxe = parcelRequire("aQVxe");


var $gvTsE = parcelRequire("gvTsE");


var $j6gAQ = parcelRequire("j6gAQ");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $7fd48b25632d9305$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1ScXu(collection) ? $aQVxe : $gvTsE, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $j6gAQ(iteratee, 2), accumulator);
    };
}
module.exports = $7fd48b25632d9305$var$createAggregator;

});

parcelRegister("aQVxe", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7e6b63f27d697568$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $7e6b63f27d697568$var$arrayAggregator;

});

parcelRegister("gvTsE", function(module, exports) {

var $bNHBU = parcelRequire("bNHBU");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c05a9000df9c8764$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $bNHBU(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $c05a9000df9c8764$var$baseAggregator;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("7TcbF", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $kCECX = parcelRequire("kCECX");


var $932sd = parcelRequire("932sd");

class $0596fc14d46b40f6$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $0596fc14d46b40f6$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $932sd.mapStep)(steps, transform, i, mapped);
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $0596fc14d46b40f6$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $0596fc14d46b40f6$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $0596fc14d46b40f6$var$collabKey = new (0, $kCECX.PluginKey)('collab');
function $0596fc14d46b40f6$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $03RpJ.default)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $kCECX.Plugin)({
        key: $0596fc14d46b40f6$var$collabKey,
        state: {
            init: ()=>new $0596fc14d46b40f6$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($0596fc14d46b40f6$var$collabKey);
                if (newState) return new $0596fc14d46b40f6$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                if (tr.docChanged) return new $0596fc14d46b40f6$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($0596fc14d46b40f6$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $0596fc14d46b40f6$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $0596fc14d46b40f6$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $0596fc14d46b40f6$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($0596fc14d46b40f6$var$collabKey, new $0596fc14d46b40f6$var$CollabState(version, newUnconfirmed));
}
function $0596fc14d46b40f6$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $0596fc14d46b40f6$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $0596fc14d46b40f6$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($0596fc14d46b40f6$var$collabKey, new $0596fc14d46b40f6$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $0596fc14d46b40f6$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $0596fc14d46b40f6$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $kCECX.TextSelection)) {
        tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($0596fc14d46b40f6$var$collabKey, newCollabState);
}
function $0596fc14d46b40f6$export$4da2109e7644e6c2(state) {
    const collabState = $0596fc14d46b40f6$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $0596fc14d46b40f6$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $0596fc14d46b40f6$export$971539697c176258(state) {
    return $0596fc14d46b40f6$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $0596fc14d46b40f6$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $0596fc14d46b40f6$export$bced9e015fcf3afa;
module.exports["collab"] = $0596fc14d46b40f6$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $0596fc14d46b40f6$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $0596fc14d46b40f6$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $0596fc14d46b40f6$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $0596fc14d46b40f6$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $0596fc14d46b40f6$export$971539697c176258;

});

parcelRegister("932sd", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

// Iterate from the specified starting index down to 0
const $b353c4f64821ca1d$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $l5rX3.AnalyticsStep))) return i;
    }
};
const $b353c4f64821ca1d$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $b353c4f64821ca1d$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $b353c4f64821ca1d$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $b353c4f64821ca1d$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $b353c4f64821ca1d$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $b353c4f64821ca1d$var$isReplaceTypeStep = (step)=>step instanceof (0, $eOaGc.ReplaceStep);
const $b353c4f64821ca1d$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $b353c4f64821ca1d$var$isReplaceTypeStep(previousRebaseableStep.step) && $b353c4f64821ca1d$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $b353c4f64821ca1d$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$b353c4f64821ca1d$var$isReplaceTypeStep(previousStep) || mapped && !$b353c4f64821ca1d$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $b353c4f64821ca1d$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $eOaGc.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $aPdNQ.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $eOaGc.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $b353c4f64821ca1d$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $b353c4f64821ca1d$export$798cdecdcbbf9755;

});

parcelRegister("6e6qw", function(module, exports) {

var $9C0Fm = parcelRequire("9C0Fm");


var $kRX0a = parcelRequire("kRX0a");


var $iDrrr = parcelRequire("iDrrr");


var $7Y8M5 = parcelRequire("7Y8M5");

/**
 * Fixed telepointer palette slot for each `@atlaskit/agent-color` brand this editor recognises by
 * a reserved identity colour rather than a hashed one. Positions also back the telepointer CSS
 * classes, so preserve them when editing the palette.
 */ const $c454c81005f3f72e$var$BRAND_PARTICIPANT_COLOR_INDEX = {
    'agent-brand-claude': 7,
    'agent-brand-rovo': 4,
    'agent-brand-chatgpt': 9,
    'agent-brand-figma': 9,
    'agent-brand-lovable': 9,
    'agent-brand-replit': 9
};
/** Brands whose registered `bold`/`boldText` values take precedence over their palette slot. */ const $c454c81005f3f72e$var$BRAND_EXACT_COLOR_SCHEMES = new Set([
    'agent-brand-chatgpt',
    'agent-brand-rovo',
    'agent-brand-figma',
    'agent-brand-lovable',
    'agent-brand-replit'
]);
/** Maps Agent Studio's semantic palette to the established telepointer palette slots. */ const $c454c81005f3f72e$var$AGENT_COLOR_TO_PARTICIPANT_COLOR_INDEX = {
    yellow: 3,
    purple: 4,
    lime: 8,
    blue: 1
};
/** The two red palette slots. Red reads as "deleted", so it never identifies a participant. */ const $c454c81005f3f72e$var$RESERVED_PARTICIPANT_COLOR_INDEXES = new Set([
    0,
    11
]);
/** Advances past a reserved slot, wrapping around the palette. */ const $c454c81005f3f72e$var$getAssignableIndex = (index)=>{
    for(let offset = 0; offset < (0, $7Y8M5.participantColors).length; offset++){
        const candidate = (index + offset) % (0, $7Y8M5.participantColors).length;
        if (!$c454c81005f3f72e$var$RESERVED_PARTICIPANT_COLOR_INDEXES.has(candidate)) return candidate;
    }
    return index;
};
function $c454c81005f3f72e$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $c454c81005f3f72e$export$60ba61eca4eb64f2(str, agentType) {
    // `agentType` may be a named id (e.g. `mcp_lovable_agent`) or a display name (e.g. `lovable`).
    const brand = agentType ? (0, $kRX0a.getThirdPartyAgentColor)({
        agentNamedId: agentType,
        agentName: agentType
    }) : undefined;
    if (brand) {
        const fixedIndex = $c454c81005f3f72e$var$BRAND_PARTICIPANT_COLOR_INDEX[brand.scheme];
        if (fixedIndex !== undefined) {
            const color = $c454c81005f3f72e$var$BRAND_EXACT_COLOR_SCHEMES.has(brand.scheme) ? {
                backgroundColor: brand.bold,
                svgBackgroundColor: brand.bold,
                textColor: brand.boldText
            } : (0, $7Y8M5.participantColors)[fixedIndex];
            return {
                index: fixedIndex,
                color: color,
                isFixed: true
            };
        }
    }
    const agentColor = agentType ? (0, $9C0Fm.getAgentColor)({
        agentId: str
    }) : undefined;
    const preferredIndex = agentColor ? $c454c81005f3f72e$var$AGENT_COLOR_TO_PARTICIPANT_COLOR_INDEX[agentColor] : $c454c81005f3f72e$export$c14f61804029af13(str) % (0, $7Y8M5.participantColors).length;
    const index = (0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') ? $c454c81005f3f72e$var$getAssignableIndex(preferredIndex) : preferredIndex;
    return {
        index: index,
        color: (0, $7Y8M5.participantColors)[index]
    };
}
module.exports["getHashCode"] = $c454c81005f3f72e$export$c14f61804029af13;
module.exports["getParticipantColor"] = $c454c81005f3f72e$export$60ba61eca4eb64f2;

});

parcelRegister("9C0Fm", function(module, exports) {
const $57a968c3db13c543$var$AGENT_COLOR_ORDER = [
    'yellow',
    'purple',
    'lime',
    'blue'
];
const $57a968c3db13c543$var$NAMED_AGENT_COLORS = {
    autodev_template_unit_test_creator: 'lime',
    autodev_template_migration_config_changer_agent: 'lime',
    autodev_template_vulnerable_dependency_updater_agent: 'lime',
    autodev_template_code_standardizer_agent: 'lime',
    autodev_template_code_observer_agent: 'lime',
    autodev_template_code_accessibility_checker_agent: 'lime',
    autodev_code_documentation_writer_agent: 'lime',
    autodev_feature_flag_cleaner_agent: 'lime',
    decision_director_agent: 'lime',
    planner_agent: 'purple',
    tech_writer_agent: 'blue',
    user_manual_writer_agent: 'yellow',
    product_requirements_expert_agent: 'yellow',
    issue_organizer_agent: 'lime',
    ops_guide_agent: 'yellow',
    discovery_and_feedback_agent: 'lime',
    jira_workflow_builder_agent: 'blue',
    itops_rca_agent: 'yellow',
    jira_trial_guide_agent: 'blue',
    daily_brief_agent: 'yellow',
    jira_admin_agent: 'blue',
    jsm_rovo_service_agent: 'yellow',
    mcp_amplitude_agent: 'blue',
    mcp_box_agent: 'blue',
    mcp_canva_agent: 'blue',
    mcp_figma_agent: 'blue',
    mcp_hubspot_agent: 'blue',
    mcp_intercom_agent: 'blue',
    mcp_gamma_agent: 'blue',
    mcp_lovable_agent: 'blue',
    mcp_replit_agent: 'blue',
    rovo_agent: 'blue',
    jira_work_agent: 'blue',
    jira_intelligent_triage_agent: 'blue',
    jira_coding_agent: 'blue'
};
const $57a968c3db13c543$export$8ff4e76da970e804 = ({ agentId: agentId, agentNamedId: agentNamedId, agentIdentityAccountId: agentIdentityAccountId })=>{
    const namedAgentColor = agentNamedId ? $57a968c3db13c543$var$NAMED_AGENT_COLORS[agentNamedId] : undefined;
    if (namedAgentColor) return namedAgentColor;
    const id = agentIdentityAccountId || agentId;
    const parsedId = Number.parseInt(id?.slice(-8).replace(/[-:]/gu, '') ?? '', 16);
    const stableAgentId = Number.isNaN(parsedId) ? 0 : parsedId;
    return $57a968c3db13c543$var$AGENT_COLOR_ORDER[stableAgentId % $57a968c3db13c543$var$AGENT_COLOR_ORDER.length] ?? 'yellow';
};
module.exports["getAgentColor"] = $57a968c3db13c543$export$8ff4e76da970e804;

});

parcelRegister("kRX0a", function(module, exports) {

var $aLnnX = parcelRequire("aLnnX");

const $8b0c132afa0fd924$var$namedBrands = {
    mcp_amplitude_agent: 'agent-brand-amplitude',
    mcp_figma_agent: 'agent-brand-figma',
    mcp_lovable_agent: 'agent-brand-lovable',
    mcp_replit_agent: 'agent-brand-replit'
};
/** Every alias a brand is identified by, normalised (trimmed, lowercased) before matching. */ const $8b0c132afa0fd924$var$displayNameBrands = {
    amplitude: 'agent-brand-amplitude',
    antigravity: 'agent-brand-antigravity',
    chatgpt: 'agent-brand-chatgpt',
    claude: 'agent-brand-claude',
    copilot: 'agent-brand-copilot',
    cortex: 'agent-brand-cortex',
    databricks: 'agent-brand-databricks',
    figma: 'agent-brand-figma',
    gemini: 'agent-brand-gemini',
    lovable: 'agent-brand-lovable',
    loveable: 'agent-brand-lovable',
    manus: 'agent-brand-manus',
    replit: 'agent-brand-replit',
    rovo: 'agent-brand-rovo',
    rovo_chat: 'agent-brand-rovo',
    slack: 'agent-brand-slack'
};
/** Canonical display name for each brand, so callers stop maintaining their own copy. */ const $8b0c132afa0fd924$var$brandDisplayNames = {
    'agent-brand-amplitude': 'Amplitude',
    'agent-brand-antigravity': 'Antigravity',
    'agent-brand-chatgpt': 'ChatGPT',
    'agent-brand-claude': 'Claude',
    'agent-brand-copilot': 'Copilot',
    'agent-brand-cortex': 'Cortex',
    'agent-brand-databricks': 'Databricks',
    'agent-brand-figma': 'Figma',
    'agent-brand-gemini': 'Gemini',
    'agent-brand-lovable': 'Lovable',
    'agent-brand-manus': 'Manus',
    'agent-brand-replit': 'Replit',
    'agent-brand-rovo': 'Rovo',
    'agent-brand-slack': 'Slack'
};
const $8b0c132afa0fd924$export$6a8569a6e7f99156 = ({ agentNamedId: agentNamedId, agentName: agentName })=>{
    const namedId = agentNamedId ?? '';
    const displayName = agentName?.trim().toLowerCase() ?? '';
    const namedScheme = Object.prototype.hasOwnProperty.call($8b0c132afa0fd924$var$namedBrands, namedId) ? $8b0c132afa0fd924$var$namedBrands[namedId] : undefined;
    const displayScheme = Object.prototype.hasOwnProperty.call($8b0c132afa0fd924$var$displayNameBrands, displayName) ? $8b0c132afa0fd924$var$displayNameBrands[displayName] : undefined;
    const scheme = namedScheme ?? displayScheme;
    return scheme ? {
        ...(0, $aLnnX.agentBrandColorSchemes)[scheme],
        name: $8b0c132afa0fd924$var$brandDisplayNames[scheme],
        scheme: scheme
    } : undefined;
};
module.exports["getThirdPartyAgentColor"] = $8b0c132afa0fd924$export$6a8569a6e7f99156;

});

parcelRegister("aLnnX", function(module, exports) {
const $73546ddb798eba32$var$themed = (light, dark)=>`light-dark(${light}, ${dark})`;
const $73546ddb798eba32$var$monochrome = {
    accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
    background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
    bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
    boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
    border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
    text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
};
/** Brand values use the product's CSS colour scheme, so existing decorations follow theme changes. */ const $73546ddb798eba32$var$brandColors = {
    'agent-brand-replit': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-lovable': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-figma': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        emphasisBackground: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-databricks': {
        accentText: $73546ddb798eba32$var$themed('#B52113', '#FF8C80'),
        background: $73546ddb798eba32$var$themed('#FFEBE9', '#352525'),
        bold: $73546ddb798eba32$var$themed('#FF3621', '#FF5F4D'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#FFBBB4', '#6D3530'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-amplitude': {
        accentText: $73546ddb798eba32$var$themed('#0052F2', '#8FB9FF'),
        background: $73546ddb798eba32$var$themed('#E5EEFE', '#242A37'),
        bold: $73546ddb798eba32$var$themed('#0052F2', '#4C8DFF'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#B9D1FC', '#2F466F'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-slack': {
        accentText: $73546ddb798eba32$var$themed('#611F69', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#EFE9F0', '#333335'),
        bold: $73546ddb798eba32$var$themed('#611F69', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#C892D1', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-copilot': $73546ddb798eba32$var$monochrome,
    'agent-brand-cortex': {
        accentText: $73546ddb798eba32$var$themed('#25074D', '#AA8AD4'),
        background: $73546ddb798eba32$var$themed('#E9E6ED', '#2D2A33'),
        bold: $73546ddb798eba32$var$themed('#25074D', '#AA8AD4'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#AA8AD4', '#504460'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-manus': {
        accentText: $73546ddb798eba32$var$themed('#34322D', '#C7C1B5'),
        background: $73546ddb798eba32$var$themed('#EBEAEA', '#302F30'),
        bold: $73546ddb798eba32$var$themed('#34322D', '#C7C1B5'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#B5AFAF', '#5A5855'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-gemini': $73546ddb798eba32$var$monochrome,
    'agent-brand-antigravity': $73546ddb798eba32$var$monochrome,
    /** ADS orange, the fixed telepointer/attribution slot Claude has always used. */ 'agent-brand-claude': {
        accentText: "var(--ds-text-accent-orange, #9E4C00)",
        background: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        bold: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        boldText: "var(--ds-text-inverse, #FFFFFF)",
        border: "var(--ds-border-accent-orange, #E06C00)",
        text: "var(--ds-text, #292A2E)"
    },
    /** ADS purple, the fixed telepointer/attribution slot Rovo has always used. */ 'agent-brand-rovo': {
        accentText: "var(--ds-text-accent-purple, #803FA5)",
        background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        bold: "var(--ds-background-accent-purple-bolder, #964AC0)",
        boldText: "var(--ds-text-inverse, #FFFFFF)",
        border: "var(--ds-border-accent-purple, #AF59E1)",
        text: "var(--ds-text, #292A2E)"
    },
    'agent-brand-chatgpt': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    }
};
const $73546ddb798eba32$export$6dbdccb358142509 = Object.fromEntries(Object.entries($73546ddb798eba32$var$brandColors).map(([scheme, colors])=>[
        scheme,
        Object.fromEntries(Object.entries(colors).map(([role, value])=>[
                role,
                `var(--${scheme}-${role}, ${value})`
            ]))
    ]));
module.exports["agentBrandColorSchemes"] = $73546ddb798eba32$export$6dbdccb358142509;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("82Ooj", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});


//# sourceMappingURL=NativeCollabComponent.bad84102.js.map
